import { useRouter } from '@capsicum/common-web';
import { useNCWTransferAmountGuardStatus } from '@capsicum/features/nc-wallet/shared';

export const useReadyToTransferGuard = () => {
	const router = useRouter();
	// TODO: Add any checks needed after the recipient selection is implemented

	return {
		onDenied: () => router.replace('/nc-wallet/send'),
		status: useNCWTransferAmountGuardStatus()
	};
};
